import { Box, Button, Modal } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSuperAdminPermissions } from "../../../../context/SuperAdmin/PermissionContext";
import CurrentAppsDropdown from "./CurrentAppsDropdown";
import OtherAppsMenu from "./OtherAppsMenu";

const AddPermissionModal = () => {
  const { isModalOpen, closeModal, isAdding, submitSelections } =
    useSuperAdminPermissions();

  const { idRol } = useParams();
  const [selectedComponents, setSelectedComponents] = useState<string[]>([]);

  const handleSubmit = () => {
    if (idRol) {
      submitSelections({ id_rol: idRol, id_componentes: selectedComponents });
      setSelectedComponents([]);
    }
  };

  const handleClose = () => {
    if (!isAdding) {
      closeModal();
    }
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <CurrentAppsDropdown />
        <OtherAppsMenu
          selectedComponents={selectedComponents}
          setSelectedComponents={setSelectedComponents}
        />

        <Box sx={{ textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isAdding || !selectedComponents.length}
            onClick={handleSubmit}
          >
            Agregar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddPermissionModal;
